import * as React from 'react';

import PropTypes from 'prop-types';

import {FunnelNumberLabel} from './funnel-number-label';

export class FunnelCloseTotals extends React.Component {
    static propTypes = {
        closedLeads: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }),
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
        }).isRequired,
        displayType: PropTypes.oneOf(['count', 'amount']),
        isBlank: PropTypes.bool.isRequired,
    };

    render() {
        const closedPercent = this.props.isBlank
            ? 0
            : this.props.closedLeads[this.props.displayType].percent;

        return (
            <div className='ui-funnel-report__total-closed'>
                <div className='ui-funnel-report__total-closed__triangle' />
                <div className='ui-funnel-report__total-closed__label-container'>
                    <span className='ui-funnel-report__total-closed__percent'>
                        {closedPercent}%
                    </span>
                    <div className='ui-funnel-report__total-closed__label'>
                        <FunnelNumberLabel
                            isBlank={this.props.isBlank}
                            isInline={true}
                            json={this.props.closedLeads}
                            displayType={this.props.displayType}
                        />
                        <span> closed</span>
                    </div>
                </div>
            </div>
        );
    }
}
